import { InjectionToken } from '@angular/core';
import type { AbstractDtoService } from './abstract-dto.service';

export const ABSTRACT_DTO_SERVICE = new InjectionToken<AbstractDtoService<any, any, any, any, any>>(
  'ABSTRACT_DTO_SERVICE',
);
